export function formatDate(date?: Date, ifEmpty: string = 'NEVER'): string {
  return !date ? ifEmpty : date.toLocaleString(
    'en-US',
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    },
  );
}
